import { createContext, useContext } from "react";
import { Product, Variant } from "../../../types/types";

interface GalleryContextValue {
  product: Product;
  enableAnalytics: boolean;
  selectedVariant: Variant;
}

type GalleryContextProviderProps = GalleryContextValue & {
  children: React.ReactNode;
};

const GalleryContext = createContext<GalleryContextValue | null>(null);

const GalleryContextProvider = ({
  children,
  product,
  enableAnalytics,
  selectedVariant,
}: GalleryContextProviderProps) => {
  return (
    <GalleryContext.Provider
      value={{ product, enableAnalytics, selectedVariant }}
    >
      {children}
    </GalleryContext.Provider>
  );
};

export const useGalleryContext = () => {
  const context = useContext(GalleryContext);
  return context;
};

export { GalleryContextProvider, GalleryContext };
